export const externalGames = [
  {
    "id": "35336",
    "title": "Tower Breaker",
    "description": "Tower Breaker is a physics-based destruction game where you throw different types of projectiles, collapse towers, break structures, and experiment with realistic physics. Pull the rope, aim, and release — each ball has unique properties and opens new ways to bring the entire city down.",
    "instructions": "Hold & Drag – pull the rope. Release – shoot the ball. Move Cursor – aim.",
    "url": "https://html5.gamemonetize.com/vzlf957tf696fqliepaa9gkcgd2omtx9/",
    "category": "Shooting",
    "tags": "crash, destroy, Mouse, Simulation",
    "thumb": "https://img.gamemonetize.com/vzlf957tf696fqliepaa9gkcgd2omtx9/512x384.jpg",
    "width": "1920",
    "height": "1080"
  },
  {
    "id": "35335",
    "title": "Flower Fairy Adventure Story",
    "description": "Welcome to Flower Fairy Adventure Story, a casual puzzle game that you can play for free. Flower Fairy lost her wings! Embark on an adventure where you solve each tiny jigsaw, dress up your girl in pretty clothes, and pave the way for the Flower Fairy.",
    "instructions": "Mouse click or tap to play",
    "url": "https://html5.gamemonetize.com/5ou6u5a1fbiqfwzd3dnraxbcwg7d28sf/",
    "category": "Puzzles",
    "tags": "Dress Up, Girls, Jigsaw, Relaxation",
    "thumb": "https://img.gamemonetize.com/5ou6u5a1fbiqfwzd3dnraxbcwg7d28sf/512x384.jpg",
    "width": "1600",
    "height": "768"
  },
  {
    "id": "35334",
    "title": "Fall Aesthetics",
    "description": "Get ready to conquer the fashion world with Fall Aesthetics! Travel the globe alongside our stylish crew and unlock your inner fashionista. Mix and match outfits inspired by the vibrant streets of New York, the golden sunsets of Tuscany, and more.",
    "instructions": "Use your mouse to play the game on a desktop tap to play on mobile devices",
    "url": "https://html5.gamemonetize.com/w2plop8mnxgcdps57l4ks5yx9lzzkuzv/",
    "category": "Girls",
    "tags": "1 Player, Dress Up, Fashion, Girl, Princess",
    "thumb": "https://img.gamemonetize.com/w2plop8mnxgcdps57l4ks5yx9lzzkuzv/512x384.jpg",
    "width": "1024",
    "height": "768"
  },
  {
    "id": "35333",
    "title": "Monster Escape: Logic Puzzle",
    "description": "Monster Escape is a thrilling logic puzzle game where every move counts! Rotate the world, dodge deadly traps, and guide your monster to the key in order to escape the dungeon.",
    "instructions": "Use the onscreen buttons to rotate the monster's world. Reach the key, avoid traps.",
    "url": "https://html5.gamemonetize.com/iswcg23g2usoz6y1uj4kjb92um44r24i/",
    "category": "Puzzles",
    "tags": ".io Games, 1 Player, Adventure, Arcade",
    "thumb": "https://img.gamemonetize.com/iswcg23g2usoz6y1uj4kjb92um44r24i/512x384.jpg",
    "width": "720",
    "height": "1280"
  },
  {
    "id": "35332",
    "title": "Jewelry Match Puzzle Game",
    "description": "Dive into the enchanting world of Jewelry Match Puzzle Game! This captivating match-3 puzzle game is perfect for puzzle enthusiasts of all ages, offering thousands of unique levels filled with challenges.",
    "instructions": "Mouse click to play Game",
    "url": "https://html5.gamemonetize.com/spacg9g3ocw5proj2m7p2bxe8fmet3dy/",
    "category": "Puzzles",
    "tags": "Arcade, Casual, Hypercasual, Puzzle, Strategy",
    "thumb": "https://img.gamemonetize.com/spacg9g3ocw5proj2m7p2bxe8fmet3dy/512x384.jpg",
    "width": "800",
    "height": "600"
  },
  {
    "id": "35331",
    "title": "Mini Pocket Game 2025",
    "description": "This relaxing toy game includes dozens of satisfying objects to touch, tap, and play with — giving you a real sense of calm and mindfulness. With realistic haptics and ASMR-inspired sounds.",
    "instructions": "Mouse click or tap to play",
    "url": "https://html5.gamemonetize.com/affiobu9gimfnfg27qqj1hiikr41zmdl/",
    "category": "Arcade",
    "tags": "2025 games, 2D, Adventure, Arcade, Best Games",
    "thumb": "https://img.gamemonetize.com/affiobu9gimfnfg27qqj1hiikr41zmdl/512x384.jpg",
    "width": "800",
    "height": "600"
  },
  {
    "id": "35330",
    "title": "Push Gold",
    "description": "PushGold is a puzzle game where you take on the role of a clever miner tasked with pushing gold blocks to their designated positions. Every move requires careful calculation because the narrow terrain can cause you to get stuck.",
    "instructions": "Use arrow buttons to move",
    "url": "https://html5.gamemonetize.com/dv7mvugfv11ml7sih07edfvus2fziyfk/",
    "category": "Puzzles",
    "tags": "1 Player, Block, Brain, Logic",
    "thumb": "https://img.gamemonetize.com/dv7mvugfv11ml7sih07edfvus2fziyfk/512x384.jpg",
    "width": "1920",
    "height": "1080"
  },
  {
    "id": "35329",
    "title": "Easy Coloring Labubu Time",
    "description": "Easy Coloring Labubu Time is super fun and free to play online coloring game for kids. Choose one of the images and make a master piece!",
    "instructions": "Mouse to play",
    "url": "https://html5.gamemonetize.com/ssspxwzt95e93vzbhabrl3rbomuzzyc5/",
    "category": "Girls",
    "tags": "Arcade, Coloring, Educational, Fun, Kids",
    "thumb": "https://img.gamemonetize.com/ssspxwzt95e93vzbhabrl3rbomuzzyc5/512x384.jpg",
    "width": "1280",
    "height": "720"
  },
  {
    "id": "35328",
    "title": "Neon Ping Pong",
    "description": "Dive into the futuristic, fast-paced action of Neon Ping Pong 2.0, The Championship Edition! This modern take on classic Pong features stunning neon graphics, intense gameplay, and multiple modes.",
    "instructions": "Player 1 Left Paddle: W/S keys (PC) or Drag Left Side (Mobile). Player 2 Right Paddle: Arrow Keys.",
    "url": "https://html5.gamemonetize.com/r4v95rc6m6gypa5pgwwdune2jngh6i4p/",
    "category": "Sports",
    "tags": "2 Player, Action, Sports",
    "thumb": "https://img.gamemonetize.com/r4v95rc6m6gypa5pgwwdune2jngh6i4p/512x384.jpg",
    "width": "800",
    "height": "600"
  },
  {
    "id": "35327",
    "title": "Cosmic Defender",
    "description": "Cosmic Defender 2.1 is a fast-paced, retro-styled vertical arcade shooter (Shmup) set against a cyberpunk sci-fi backdrop. Pilot the powerful Cosmic Defender starship to fend off a galaxy-wide invasion.",
    "instructions": "Move Ship: Mouse/Touch Drag or WASD/Arrow keys. Fire: Hold Click/Touch.",
    "url": "https://html5.gamemonetize.com/hpps4rzujsi2jzxw7thbkypm3sb4mq0q/",
    "category": "Shooting",
    "tags": "1 Player, Action, Fight, Retro, Sci-Fi, Shooter",
    "thumb": "https://img.gamemonetize.com/hpps4rzujsi2jzxw7thbkypm3sb4mq0q/512x384.jpg",
    "width": "800",
    "height": "600"
  },
  {
    "id": "35326",
    "title": "Monster Egg",
    "description": "Begin the wildest evolution adventure ever in Monster Egg! This is not just a simple running game. It’s a fast-paced action platform full of monsters, DNA collecting, and epic battles.",
    "instructions": "Mouse click or tap to play",
    "url": "https://html5.gamemonetize.com/a6mlyusljrtcoyhetis4m6u4rxbdymda/",
    "category": "Arcade",
    "tags": "Action, eggs, Monster, running",
    "thumb": "https://img.gamemonetize.com/a6mlyusljrtcoyhetis4m6u4rxbdymda/512x384.jpg",
    "width": "1334",
    "height": "750"
  },
  {
    "id": "35325",
    "title": "Shark Boy",
    "description": "Shark Boy is a colorful underwater puzzle game where you will accompany the boy and his friendly whale on a quest to find precious golden shells. Skillfully utilize anchors to pull, swing, or create momentum.",
    "instructions": "Use mouse to play",
    "url": "https://html5.gamemonetize.com/wsyqf99n87edjqqnatiyhiqb8qv5aaim/",
    "category": "Puzzles",
    "tags": "Brain, Casual, Click, Logic",
    "thumb": "https://img.gamemonetize.com/wsyqf99n87edjqqnatiyhiqb8qv5aaim/512x384.jpg",
    "width": "1920",
    "height": "1080"
  },
  {
    "id": "35324",
    "title": "Monster Boom Boom",
    "description": "Monster Boom Boom is a fun and challenging puzzle game where you use special vials created from green monsters to eliminate all the monsters on the arena. Each move is precious because the number of actions is limited.",
    "instructions": "Use mouse to play",
    "url": "https://html5.gamemonetize.com/762jwzjxrf7he4af39rywycw6xpzib4d/",
    "category": "Puzzles",
    "tags": "Alien, Brain, Click, Monster, Puzzle",
    "thumb": "https://img.gamemonetize.com/762jwzjxrf7he4af39rywycw6xpzib4d/512x384.jpg",
    "width": "1920",
    "height": "1080"
  },
  {
    "id": "35323",
    "title": "Red Up Survival",
    "description": "Red up is an amazing platformer game, where you can control fireboy on his stick adventure to rescue watergirl. Escape from the castle full of tricks and mysterious puzzles.",
    "instructions": "WASD or Arrow keys to move.",
    "url": "https://html5.gamemonetize.com/uvzrxu8peda71uin0gxeqdinrly6kwob/",
    "category": "Adventure",
    "tags": "2025 games, 3D, Action, Adventure",
    "thumb": "https://img.gamemonetize.com/uvzrxu8peda71uin0gxeqdinrly6kwob/512x384.jpg",
    "width": "800",
    "height": "600"
  },
  {
    "id": "35322",
    "title": "Mini No Wifi Games 2024",
    "description": "Relaxation isn't just about what you do – it's also about how you feel. That's why we've included exercises to help you chill out and de-stress. Our anti-stress mobile game is always at your fingertips.",
    "instructions": "Mouse click or tap to play",
    "url": "https://html5.gamemonetize.com/0bxsnepcupr0twu3umvmdxnso7kzwwr3/",
    "category": "Arcade",
    "tags": "Casual, free games, Relaxation",
    "thumb": "https://img.gamemonetize.com/0bxsnepcupr0twu3umvmdxnso7kzwwr3/512x384.jpg",
    "width": "800",
    "height": "600"
  },
  {
    "id": "35321",
    "title": "Cozy Pizzeria",
    "description": "Run a cozy pizza shop that grows into a city-wide chain. Hire and manage staff, upgrade ovens and counters, buy new land, balance morale to prevent strikes, and keep the dough—and cash—rolling.",
    "instructions": "Mouse click or tap to play",
    "url": "https://html5.gamemonetize.com/la3akmhdsim4g3vztf22xdk3recbrkec/",
    "category": "Hypercasual",
    "tags": "3D, Casual, Management, pizza, Restaurant",
    "thumb": "https://img.gamemonetize.com/la3akmhdsim4g3vztf22xdk3recbrkec/512x384.jpg",
    "width": "750",
    "height": "1334"
  },
  {
    "id": "35320",
    "title": "Found It! Hidden Object",
    "description": "The addictive & FREE hidden objects puzzle game for you to train your brain and kill boredom! Take the challenge and relax with super fun hidden object puzzles and casual finding games.",
    "instructions": "Mouse click to play Game",
    "url": "https://html5.gamemonetize.com/rpque3q0zlm0z2jiecj7wmokvr4wzai8/",
    "category": "Puzzles",
    "tags": "Arcade, Casual, Hypercasual, Puzzle",
    "thumb": "https://img.gamemonetize.com/rpque3q0zlm0z2jiecj7wmokvr4wzai8/512x384.jpg",
    "width": "800",
    "height": "600"
  },
  {
    "id": "35319",
    "title": "Number Merger",
    "description": "Dive into the ultimate idle puzzle experience with Number Merger Infinite! Drag and merge blocks to reach impossible numbers like 99,999 and beyond.",
    "instructions": "drag and click or touch",
    "url": "https://html5.gamemonetize.com/ylbicwd30vva0awbilt3x3ryxjkg5v59/",
    "category": "Clicker",
    "tags": "1 Player, 2D, Click, Clicker, HTML5, idle",
    "thumb": "https://img.gamemonetize.com/ylbicwd30vva0awbilt3x3ryxjkg5v59/512x384.jpg",
    "width": "800",
    "height": "600"
  },
  {
    "id": "35318",
    "title": "Draw Dot Picture Game",
    "description": "Welcome to Draw One Miss Part Brain Games, the addictive puzzle game where logic, drawing, and brain games come together! Test your skills by identifying the missing part in each scene.",
    "instructions": "Mouse click to play Game",
    "url": "https://html5.gamemonetize.com/nj974v2hmarol6ij7nr8op8qt1cq5x33/",
    "category": "Hypercasual",
    "tags": "Casual, Draw, Drawing, Hypercasual",
    "thumb": "https://img.gamemonetize.com/nj974v2hmarol6ij7nr8op8qt1cq5x33/512x384.jpg",
    "width": "800",
    "height": "600"
  },
  {
    "id": "35317",
    "title": "Snake Battle",
    "description": "Experience the Ultimate IO Battle Thrill! In Snake Battle, consume glowing dots to grow and use tactical maneuvers to cut off enemies, forcing them to crash into you!",
    "instructions": "PC: Arrow keys or WASD to move. Mobile: Touch control.",
    "url": "https://html5.gamemonetize.com/69an8dj2qbecd9ek1dca4e9rmq6g3d6e/",
    "category": "Hypercasual",
    "tags": "1 Player, Boy, Casual",
    "thumb": "https://img.gamemonetize.com/69an8dj2qbecd9ek1dca4e9rmq6g3d6e/512x384.jpg",
    "width": "800",
    "height": "600"
  }
];